import { render, staticRenderFns } from "./AvatarGroup.vue?vue&type=template&id=350f9f8f&scoped=true"
import script from "./AvatarGroup.vue?vue&type=script&lang=js"
export * from "./AvatarGroup.vue?vue&type=script&lang=js"
import style0 from "./AvatarGroup.vue?vue&type=style&index=0&id=350f9f8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f9f8f",
  null
  
)

export default component.exports